import React from 'react'
import { VerticalTimeline } from 'react-vertical-timeline-component'
import { motion } from 'framer-motion'
import 'react-vertical-timeline-component/style.min.css'
import { experiences } from '../../Constants'
import Magazines from '../../Magazines/Magazines'
import { textVariant } from '../../utils/motion'
import ExprienceCard from './ExprienceCard'
import Tech from './Tech'

const Exprience = () => {
  return (
    <>
      <motion.section variants={textVariant()} className=' mt-32 px-2'>
        <p className='sm:text-[18px] text-[14px] text-primary dark:text-secondary tracking-wider uppercase font-medium'>
          What I have done so far.
        </p>
        <h2 className='text-[#915eff] dark:text-white font-black md:text-[60px] sm:text-[50px] xs:text-[40px] text-[30px]'>
          Work Exprience.
        </h2>
      </motion.section>
      <section className='mt-20 flex flex-col '>
        <VerticalTimeline>
          {experiences.map((exprience, index) => (
            <ExprienceCard key={index} exprience={exprience} />
          ))}
        </VerticalTimeline>
      </section>
      <section className='mt-20'>
        <Tech />
      </section>
    </>
  )
}

export default Magazines(Exprience, 'exprience')
